<template>
  <BlackoutPeriodForm v-if="!isLoading" :urlIds="urlIds" :startDate="startDate" :endDate="endDate" :disable-repeating="true" @submit="onSubmit($event)" />
</template>

<script>
  import BlackoutPeriodService from '../services/blackout-period.service';
  import BlackoutPeriodForm from './BlackoutPeriodForm';

  export default {
    name: 'BlackoutPeriodEdit',
    components: {
      BlackoutPeriodForm
    },
    data() {
      return {
        isLoading: true,
        urlIds: [],
        startDate: null,
        endDate: null
      };
    },
    beforeMount() {
      this.startDate = decodeURIComponent(this.$route.query.start);
      this.endDate = decodeURIComponent(this.$route.query.end);
    },
    mounted() {
      this.getBlackoutPeriod();
    },
    methods: {
      async onSubmit(data) {
        try {
          const start = (data.start || '').replace('.000Z', '');
          const end = (data.end || '').replace('.000Z', '');
          const body = {
            start,
            end,
            url_ids: data.url_ids
          };
          await BlackoutPeriodService.update(this.startDate, this.endDate, body);
          this.$showSuccessMessage('Updated Blackout period');
          this.$router.push('/blackout-periods/list');
        } catch (error) {
          this.$showMultiErrorMessage(error.messages || []);
        }
      },
      async getBlackoutPeriod() {
        const { url_ids } = await BlackoutPeriodService.get(this.startDate, this.endDate);
        this.urlIds = url_ids;
        setTimeout(() => {
          this.isLoading = false;
        });
      }
    }
  };
</script>

<style lang="scss" scoped></style>
